import React from "react";
import Carousel from "react-multi-carousel";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";
import { useTranslation } from "../../i18n";

// source
import { projectTools } from "../../source/serviceFeaturesSource";
export default function ServiceFeaturesComponents() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const { t } = useTranslation();

  const responsiveTools = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 5,
    },
  };

  return (
    <div className="services_content_features">
      {isMobile ? (
        // Mobile View
        <div className="row">
          <div className="col-12">
            <div className="features_title font-vietnam-600 font-size-36 lh-1 mt-2">
              {t.services.featuresTitle}
            </div>
            <div className="features_content mt-3">
              {t.services.features.map((feature, index) => (
                <React.Fragment key={feature}>
                  <div className="font-vietnam-500">
                    {index + 1}. {feature}
                  </div>
                  <p className="font-vietnam-200-italic">
                    {t.services.featureBody}
                  </p>
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="col-12">
            <div className="project-growth py-2">
              <div className="project-growth_total d-flex justify-content-center">
                <label
                  htmlFor=""
                  className="font-size-36 fw-bold font-vietnam-100"
                >
                  25+
                </label>
                <div className="description font-vietnam-400-italic">
                  {t.services.growthTotal}
                </div>
              </div>
              <div className="project-growth_type_mobile d-flex justify-content-center">
                <label
                  htmlFor=""
                  className="font-size-36 fw-bold font-vietnam-100"
                >
                  10+
                </label>
                <div className="description font-vietnam-400-italic">
                  {t.services.growthMobile}
                </div>
              </div>
              <div className="project-growth_type_website d-flex justify-content-center">
                <label
                  htmlFor=""
                  className="font-size-36 fw-bold font-vietnam-100"
                >
                  15+
                </label>
                <div className="description font-vietnam-400-italic">
                  {t.services.growthWebsite}
                </div>
              </div>
            </div>
            <div className="tools-project">
              <label htmlFor="" className="font-size-36 font-vietnam-600">
                {t.services.toolsProject}
              </label>
              <div className="tools-project_images">
                <Carousel
                  responsive={responsiveTools}
                  autoPlaySpeed={2000}
                  autoPlay={true}
                  infinite={true}
                  ssr={true}
                  arrows={false}
                >
                  {projectTools.map((tool) => (
                    <div
                      key={tool.id}
                      data-aos="zoom-in"
                      data-aos-anchor-placement="top-center"
                      data-aos-duration={"1" + tool.id * 1000}
                    >
                      <img src={tool.image} alt={tool.title} loading="lazy" />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Desktop View
        <div className="row">
          <div className="col-3">
            <div className="features_title font-vietnam-600 font-size-36 lh-1 mt-2">
              {t.services.featuresTitle}
            </div>
            <div className="features_content mt-3">
              {t.services.features.map((feature, index) => (
                <React.Fragment key={feature}>
                  <div className="font-vietnam-500">
                    {index + 1}. {feature}
                  </div>
                  <p className="font-vietnam-200-italic">
                    {t.services.featureBody}
                  </p>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-anchor-placement="top-center"
            data-aos-duration={"500"}
            className="col-3 images-features"
          >
            <img
              src={require("../../assets/images/services/services_features.jpg")}
              alt="services"
              width={"100%"}
              loading="lazy"
            />
          </div>
          <div className="col-6">
            <div className="project-growth py-2 px-4">
              <div className="project-growth_total d-flex justify-content-center">
                <label
                  htmlFor=""
                  className="font-size-36 fw-bold font-vietnam-100"
                >
                  25+
                </label>
                <div className="description font-vietnam-400-italic">
                  {t.services.growthTotal}
                </div>
              </div>
              <div className="project-growth_type_mobile d-flex justify-content-center">
                <label
                  htmlFor=""
                  className="font-size-36 fw-bold font-vietnam-100"
                >
                  10+
                </label>
                <div className="description font-vietnam-400-italic">
                  {t.services.growthMobile}
                </div>
              </div>
              <div className="project-growth_type_website d-flex justify-content-center">
                <label
                  htmlFor=""
                  className="font-size-36 fw-bold font-vietnam-100"
                >
                  15+
                </label>
                <div className="description font-vietnam-400-italic">
                  {t.services.growthWebsite}
                </div>
              </div>
            </div>
            <div className="tools-project">
              <label htmlFor="" className="font-size-36 font-vietnam-600">
                {t.services.toolsProject}
              </label>
              <div className="tools-project_images">
                <Carousel
                  responsive={responsiveTools}
                  autoPlaySpeed={2000}
                  autoPlay={true}
                  infinite={true}
                  ssr={true}
                  arrows={false}
                >
                  {projectTools.map((tool) => (
                    <div
                      key={tool.id}
                      data-aos="zoom-in"
                      data-aos-anchor-placement="top-center"
                      data-aos-duration={"1" + tool.id * 1000}
                    >
                      <img src={tool.image} alt={tool.title} loading="lazy" />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
